var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch, Model, Prop, Vue } from 'vue-property-decorator';
/** 按照 半勾选 全勾选 不勾选的顺序进行的三态选择框 提供tooltip插槽进行嵌入 */
let TripleCheckBox = class TripleCheckBox extends Vue {
  constructor() {
    super(...arguments);
    this.checkBoxStatusIndex = 0;
  }
  /** index=0是半勾选 */
  get indeterminate() {
    return this.checkBoxStatusIndex === 0;
  }
  get checkBoxChecked() {
    return this.checkBoxStatusIndex !== 2;
  }
  onValueChange(value) {
    this.checkBoxStatusIndex = this.valueSequence.indexOf(value);
  }
  clickCheckBox() {
    this.checkBoxStatusIndex = (this.checkBoxStatusIndex + 1) % this.valueSequence.length;
    this.$emit('change', this.valueSequence[this.checkBoxStatusIndex]);
  }
  render() {
    const h = arguments[0];
    return h("a-checkbox", {
      "attrs": {
        "checked": this.checkBoxChecked,
        "indeterminate": this.indeterminate
      },
      "on": {
        "click": this.clickCheckBox
      }
    }, [this.$slots.default]);
  }
};
__decorate([Model('change')], TripleCheckBox.prototype, "value", void 0);
__decorate([Prop({
  type: Array
})], TripleCheckBox.prototype, "valueSequence", void 0);
__decorate([Watch('value', {
  immediate: true
})], TripleCheckBox.prototype, "onValueChange", null);
TripleCheckBox = __decorate([Component({
  name: 'TripleCheckBox'
})], TripleCheckBox);
export { TripleCheckBox };
//# sourceMappingURL=TripleCheckBox.js.map
